<template>
  <v-alert :type="type" class="alert-content" v-if="active" border="left">
    {{ text }}
  </v-alert>
</template>

<script>
import eventBus from '../../utils/eventBus'
export default {
  name: 'Alert',
  data () {
    return {
      active: false,
      text: '등록되었습니다.',
      type: 'success'
    }
  },
  watch: {
    active: function (newValue) {
      if (newValue) {
        setTimeout(this.resetAlert, 3000)
      }
    }
  },
  methods: {
    resetAlert () {
      this.active = false
      this.text = '등록되었습니다.'
      this.type = 'success'
      this.time = 3000
    },
    alertContent (payload) {
      this.active = payload.active
      this.text = payload.text || this.text
      this.type = payload.type || this.type
      this.time = payload.time || this.time
    }
  },
  beforeMount () {
    eventBus.$on('alert', this.alertContent)
  },
  beforeDestroy () {
    eventBus.$off('alert', this.alertContent)
  }
}
</script>

<style scoped lang="scss">
  .alert-content {
    min-width: 300px;
    position: fixed;
    left: calc(50% - 150px);
    top: 120px;
  }
</style>
